import { useState } from "react";
import ProfileTab from "./settings/ProfileTab";
import OrgConfigTab from "./settings/OrgConfigTab";
import BillingTab from "./settings/BillingTab";
import AccountTab from "./settings/AccountTab";
import "../styles/settings.css";

const TABS = [
  { id: "profile", label: "Profile", icon: "🏢" },
  { id: "config", label: "Organization", icon: "⚙️" },
  { id: "billing", label: "Billing", icon: "💳" },
  { id: "account", label: "Account", icon: "🔐" },
] as const;

type TabId = (typeof TABS)[number]["id"];

export default function Settings() {
  const [activeTab, setActiveTab] = useState<TabId>("profile");

  return (
    <div className="settings-page">
      <h1>Settings</h1>
      <p className="page-subtitle">
        Manage your organization, preferences, and account
      </p>

      <div className="settings-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`settings-tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
            type="button"
          >
            <span className="tab-icon">{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="settings-tab-content">
        {activeTab === "profile" && <ProfileTab />}
        {activeTab === "config" && <OrgConfigTab />}
        {activeTab === "billing" && <BillingTab />}
        {activeTab === "account" && <AccountTab />}
      </div>
    </div>
  );
}
